(async function () {
  try {
    if (!window.ALYX_CUSTOMER_ID) return;

    var ALYX_DEBUG = window.ALYX_DEBUG === true;
    function log() { if (ALYX_DEBUG) console.log.apply(console, arguments); }

    var CLIENT_ID = '33de19e8-9dc3-49f5-b742-c5d33a49ddda';
    var API_BASE = 'https://alyx.gedl.cl';
    var REDIRECT_URI = window.location.origin + '/?alyx_rewards_auth=1';
    var OIDC_URL = window.location.origin + '/.well-known/openid-configuration';

    var K_ATTEMPT = 'alyx_rewards_attempted';
    var K_VERIFIER = 'alyx_pkce_verifier';
    var K_CTOKEN = 'alyx_customer_access_token';
    var K_BEARER = 'alyx_api_bearer';

    var path = window.location.pathname;
    var SAFE_PAGE = path === '/' || path.indexOf('/collections') === 0 || path.indexOf('/blogs') === 0;
    var POPUP = !!window.opener;

    function setJson(k, o) { sessionStorage.setItem(k, JSON.stringify(o)); }
    function getJson(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } }
    function fresh(o) { return o && o.expires && Date.now() < o.expires; }
    function b64url(buf) { return btoa(String.fromCharCode.apply(null, new Uint8Array(buf))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
    function rand() { var a = new Uint8Array(32); crypto.getRandomValues(a); return b64url(a); }

    var params = new URLSearchParams(window.location.search);

    if (params.get('alyx_rewards_auth') !== null) {
      var code = params.get('code');
      var verifier = sessionStorage.getItem(K_VERIFIER);
      var returnTo = sessionStorage.getItem('alyx_return_to');
      sessionStorage.removeItem(K_VERIFIER);
      sessionStorage.removeItem('alyx_return_to');
      history.replaceState({}, '', window.location.pathname);
      if (code && verifier) {
        try {
          var oidc = await (await fetch(OIDC_URL)).json();
          var body = new URLSearchParams();
          body.append('grant_type', 'authorization_code');
          body.append('client_id', CLIENT_ID);
          body.append('redirect_uri', REDIRECT_URI);
          body.append('code', code);
          body.append('code_verifier', verifier);
          var data = await (await fetch(oidc.token_endpoint, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() })).json();
          if (data.access_token) setJson(K_CTOKEN, { token: data.access_token, expires: Date.now() + (data.expires_in || 3600) * 1000 });
        } catch (e) { log('Alyx: token exchange fallo', e); }
      }
      if (returnTo) window.location.href = returnTo;
      return;
    }

    var cToken = getJson(K_CTOKEN);
    if (!fresh(cToken) && !sessionStorage.getItem(K_ATTEMPT) && SAFE_PAGE && !POPUP) {
      sessionStorage.setItem(K_ATTEMPT, '1');
      sessionStorage.setItem('alyx_return_to', window.location.href);
      try {
        var oidc2 = await (await fetch(OIDC_URL)).json();
        var verifier2 = rand();
        sessionStorage.setItem(K_VERIFIER, verifier2);
        var challenge = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier2)).then(b64url);
        var url = new URL(oidc2.authorization_endpoint);
        url.searchParams.set('client_id', CLIENT_ID);
        url.searchParams.set('scope', 'openid email customer-account-api:full');
        url.searchParams.set('response_type', 'code');
        url.searchParams.set('redirect_uri', REDIRECT_URI);
        url.searchParams.set('state', rand());
        url.searchParams.set('nonce', rand());
        url.searchParams.set('prompt', 'none');
        url.searchParams.set('code_challenge', challenge);
        url.searchParams.set('code_challenge_method', 'S256');
        window.location.href = url.toString();
      } catch (e) { log('Alyx: login silencioso fallo', e); }
      return;
    }
    if (!fresh(cToken)) return;

    var bearer = getJson(K_BEARER);
    if (!fresh(bearer)) {
      try {
        var x = await fetch(API_BASE + '/api/auth/exchange', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: cToken.token }) });
        if (x.status === 200) {
          var d = await x.json();
          setJson(K_BEARER, { token: d.token, expires: Date.now() + 5 * 3600 * 1000 });
          bearer = getJson(K_BEARER);
        } else if (x.status === 401) {
          sessionStorage.removeItem(K_CTOKEN);
        }
      } catch (e) { log('Alyx: exchange fallo', e); }
    }
    if (!fresh(bearer)) return;

    try {
      var rw = await fetch(API_BASE + '/api/me/reward', { headers: { Authorization: 'Bearer ' + bearer.token } });
      if (rw.status === 401) { sessionStorage.removeItem(K_BEARER); return; }
      if (rw.status === 200) renderCredits(await rw.json());
    } catch (e) { log('Alyx: reward fallo', e); }

    function renderCredits(reward) {
      var available = reward && reward.reward && reward.reward.available === true;
      if (!available) return;
      var pending = (reward.reward.pending || 0) + ((reward.reward.single_credits && reward.reward.single_credits.available) || 0);
      var label = pending === 1 ? '1 credit' : pending + ' credits';
      var portalUrl = reward.subscription && reward.subscription.portal_url;

      var homeLink = null;
      var links = document.querySelectorAll('.menu-list__list-item a.menu-list__link');
      for (var i = 0; i < links.length; i++) {
        if ((links[i].textContent || '').trim().toLowerCase() === 'home') { homeLink = links[i]; break; }
      }
      var ul = homeLink ? homeLink.closest('ul') : null;
      var fallback = document.querySelector('.account-button.header-actions__action, .header-actions__action, a[aria-label="Cart"]');
      if (!ul && !fallback) return;

      var btn = document.createElement('a');
      btn.id = 'alyx-credits-btn';
      btn.href = '#';
      btn.textContent = label;
      btn.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-height:32px;padding:5px 14px;border-radius:999px;text-decoration:none;font-size:13px;line-height:1;font-family:inherit;font-weight:600;background:#e8e1d7;color:#121212;border:1px solid #e8e1d7;cursor:pointer;white-space:nowrap;transition:opacity .2s ease,transform .2s ease;';
      btn.addEventListener('mouseenter', function () { btn.style.opacity = '0.9'; btn.style.transform = 'translateY(-1px)'; });
      btn.addEventListener('mouseleave', function () { btn.style.opacity = '1'; btn.style.transform = ''; });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (portalUrl) {
          window.location.href = portalUrl;
        } else {
          alert('Recompensas acumuladas: ' + pending);
        }
      });

      function applyLayout() {
        if (window.matchMedia('(max-width: 767px)').matches) {
          btn.style.position = 'fixed';
          btn.style.left = '16px';
          btn.style.bottom = '16px';
          btn.style.zIndex = '9999';
        } else {
          btn.style.position = '';
          btn.style.left = '';
          btn.style.bottom = '';
          btn.style.zIndex = '';
        }
      }
      applyLayout();
      window.addEventListener('resize', applyLayout);

      if (ul) {
        var wrapper = document.createElement('div');
        wrapper.style.cssText = 'display:inline-flex;align-items:center;';
        wrapper.appendChild(btn);
        ul.parentNode.insertBefore(wrapper, ul);
      } else {
        fallback.parentNode.insertBefore(btn, fallback);
      }
    }
  } catch (e) {
    if (window.ALYX_DEBUG === true) console.error('Alyx rewards:', e);
  }
})();